var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 63,
    viewBox: "0 0 161 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03195 54.8934V17.6276C4.71732 14.0212 10.7786 6.32764 13.5406 4.40425C16.3027 2.48085 58.4242 2 79.1397 2H144.739L158.549 16.4255V52.4892C158.549 54.8934 156.247 59.7019 153.946 60.904C152.104 61.8657 129.394 60.5033 118.269 59.7019H19.2949C4.56384 59.7019 1.64833 56.4962 2.03195 54.8934Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.486 50.1001C115.71 50.1959 122.596 49.8606 122.849 49.8845C128.652 50.124 136.851 50.2198 142.654 50.2198C149.402 50.2198 147.582 43.1066 147.951 39.8014C148.803 31.9697 148.181 27.0838 148.181 19.2281C148.181 15.2044 148.043 15.7313 148.043 11.7077C148.043 8.83365 149.217 2.31916 143.23 2.1994C141.503 2.17545 133.788 2.24731 128.445 2.03175C124.76 1.8641 97.3786 2.41496 97.3786 2.41496L82.9623 2.70236L69.283 2.77421L49.6161 2.43891C49.6161 2.43891 38.2627 2.75026 32.6206 3.25322C29.9031 3.49272 27.9917 3.03767 25.2973 3.39692C22.5108 3.75618 17.0298 2.79816 14.4505 4.25913C11.5719 5.88776 12.4471 10.0312 12.0786 13.1447C11.4338 18.7491 11.6641 24.3774 11.7792 30.0058C11.8713 34.3647 11.641 38.4363 12.2168 42.7473C12.5161 44.9508 12.401 47.6332 14.3354 48.8786C19.3327 50.0282 23.3399 50.9623 27.0706 50.5552C29.5347 50.2917 40.2202 50.4594 42.9607 50.2677C45.1254 50.124 45.9314 49.9803 49.3167 49.8127C52.7481 49.645 56.2255 50.0043 59.6568 49.9085C63.5948 49.7887 102.468 49.9085 104.38 49.9324L112.509 50.148L112.486 50.1001Z",
    stroke: "black",
    strokeWidth: 3.59255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7468 47.2021L4.82471 55.8243",
    stroke: "black",
    strokeWidth: 3.59255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.642 47.2021L157.807 56.7344",
    stroke: "black",
    strokeWidth: 3.59255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4281 4.21094L4.24923 15.1802C3.07474 16.4496 2.40692 18.15 2.40692 19.9224V23.8981C2.40692 35.035 2.45305 39.2024 2.47608 50.3633C2.47608 51.944 2.49903 53.6205 3.25899 55.0096C4.6868 57.6442 8.07206 58.1711 10.9968 58.3627C21.452 58.9854 31.9303 58.8896 42.3855 58.8417C47.7744 58.8177 53.1863 58.7938 58.5751 58.8177C88.9736 58.8177 120.109 59.3446 150.461 60.7817C152.166 60.8535 153.985 60.9254 155.459 60.0392C158.176 58.4106 158.66 54.2432 158.821 51.4889C158.982 49.1897 159.005 46.8665 158.982 44.5433C158.89 36.1128 159.051 32.7358 158.982 24.449V18.6051C158.982 17.4076 158.545 16.258 157.739 15.4197L147.283 4.25884",
    stroke: "black",
    strokeWidth: 3.59255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartButton);
export default __webpack_public_path__ + "static/media/start-button.26a8b12eab4f7dc9582a6cc6adaf5c5d.svg";
export { ForwardRef as ReactComponent };